/* Date civili italiane: nessun confronto nel fuso del dispositivo.
   Un timer per blocco: al minuto o al secondo durante il countdown richiesto.
   Sospeso a scheda nascosta e rimosso in editor. */
(() => {
  if (customElements.get('extro-delivery')) return;
  const dayMs = 86400000;
  const rome = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
  const shortDate = new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'short', timeZone: 'UTC' });
  const fullDate = new Intl.DateTimeFormat('it-IT', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
  const fixedHolidays = new Set(['01-01', '01-06', '04-25', '05-01', '06-02', '08-15', '11-01', '12-08', '12-25', '12-26']);
  const easterMondays = new Map();
  const key = date => new Date(date).toISOString().slice(0, 10);
  function easterMonday(year) {
    if (easterMondays.has(year)) return easterMondays.get(year);
    // Computo gregoriano: anche Pasquetta resta valida negli anni successivi.
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    const result = Date.UTC(year, Math.floor(n / 31) - 1, n % 31 + 2);
    easterMondays.set(year, result);
    return result;
  }
  class ExtroDelivery extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-manual')) return;
      this.closed = new Set((this.dataset.closed || '').split(/[\s,;]+/).filter(Boolean));
      this.onVisibility = () => { clearTimeout(this.timer); if (!document.hidden) this.tick(); };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.onVisibility();
      // In editor il custom element puo' essere collegato prima dei figli.
      if (!this.querySelector('[data-delivery-lead]')) {
        this.readyFrame = requestAnimationFrame(() => { if (this.isConnected) this.onVisibility(); });
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.readyFrame);
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    workingDay(date) {
      const d = new Date(date), iso = key(date);
      return d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !fixedHolidays.has(iso.slice(5)) &&
        date !== easterMonday(d.getUTCFullYear()) && !this.closed.has(iso);
    }
    nextWorkingDay(date) {
      while (!this.workingDay(date)) date += dayMs;
      return date;
    }
    setText(selector, value) {
      const el = this.querySelector(selector);
      if (el && el.textContent !== value) el.textContent = value;
    }
    tick() {
      clearTimeout(this.timer);
      const now = new Date();
      const parts = Object.fromEntries(rome.formatToParts(now).map(p => [p.type, p.value]));
      const today = Date.UTC(+parts.year, +parts.month - 1, +parts.day);
      const configured = Number(this.dataset.cutoff);
      const cutoff = Number.isFinite(configured) ? Math.max(0, Math.min(23, configured)) : 14;
      const remaining = cutoff * 60 - (+parts.hour * 60 + +parts.minute);
      const pickup = this.nextWorkingDay(today + (remaining > 0 ? 0 : dayMs));
      const arrival = this.nextWorkingDay(pickup + dayMs);
      const delay = Math.max(0, Math.min(30, Number(this.dataset.delayDays) || 0));
      const latest = this.nextWorkingDay(this.nextWorkingDay(arrival + dayMs) + delay * dayMs);
      const label = date => date === today ? 'Oggi' : date === today + dayMs ? 'Domani' : shortDate.format(date);
      let duration = `${Math.floor(remaining / 60) ? Math.floor(remaining / 60) + ' h ' : ''}${remaining % 60} min`;
      const secondsMode = this.hasAttribute('data-countdown-seconds');
      if (secondsMode) {
        const seconds = Math.max(0, remaining * 60 - now.getSeconds());
        const hours = Math.floor(seconds / 3600), minutes = Math.floor(seconds % 3600 / 60);
        duration = `${hours ? hours + ' ore, ' : ''}${minutes} min, ${seconds % 60} sec`;
      }
      this.setText('[data-delivery-lead]', pickup === today ? `Ordina entro ${duration}` : 'Ordina ora');
      const arrivalLabel = arrival === today + dayMs ? 'domani' : fullDate.format(arrival);
      this.setText('[data-delivery-estimate]', `Ricevi ${arrivalLabel} – ${fullDate.format(latest)} · consegna stimata`);
      this.setText('[data-delivery-pickup]', label(pickup));
      this.setText('[data-delivery-arrival]', label(arrival));
      // Il riepilogo comunica la finestra completa; il percorso mostra il primo arrivo stimato.
      const interval = secondsMode && pickup === today ? 1000 - now.getMilliseconds() : 60000 - now.getSeconds() * 1000 - now.getMilliseconds();
      this.timer = setTimeout(() => this.tick(), interval);
    }
  }
  customElements.define('extro-delivery', ExtroDelivery);
})();
